import MainContent from "../components/MainContent";
import Layout from "../components/Layout";

const PlaylistsPage = () => (
  <Layout>
    <MainContent contentType="playlists" />
  </Layout>
);

export default PlaylistsPage;
